var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.533,
    height: 50,
    viewBox: "0 0 52.533 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pet",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91205",
    "data-name": "Path 91205",
    d: "M28.391,40.8H16.61A12.782,12.782,0,0,1,3.69,26.787,19.033,19.033,0,0,1,9.884,14.4,18.993,18.993,0,0,1,22.734,9.25c8.915,0,17.376,7.167,18.861,15.976A13.281,13.281,0,0,1,38.786,36.2a12.628,12.628,0,0,1-4.491,3.371A14.262,14.262,0,0,1,28.391,40.8ZM22.734,11.288A17.4,17.4,0,0,0,5.721,26.956,10.745,10.745,0,0,0,16.61,38.765H28.391a10.963,10.963,0,0,0,11.194-13.2A17.722,17.722,0,0,0,22.734,11.288Z",
    transform: "translate(1.565 8.447)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91206",
    "data-name": "Path 91206",
    d: "M14.388,16.086a7.168,7.168,0,1,1,7.168-7.168A7.176,7.176,0,0,1,14.388,16.086Zm0-12.3a5.13,5.13,0,1,0,5.13,5.13A5.136,5.136,0,0,0,14.388,3.788Z",
    transform: "translate(6.787 -2.5)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91207",
    "data-name": "Path 91207",
    d: "M20.488,15.827a5.938,5.938,0,1,1,5.938-5.938A5.945,5.945,0,0,1,20.488,15.827Zm0-9.838a3.9,3.9,0,1,0,3.9,3.9A3.9,3.9,0,0,0,20.488,5.988Z",
    transform: "translate(17.486 0.711)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91208",
    "data-name": "Path 91208",
    d: "M23.459,18.367a4.709,4.709,0,1,1,4.709-4.709A4.714,4.714,0,0,1,23.459,18.367Zm0-7.379a2.67,2.67,0,1,0,2.67,2.67A2.673,2.673,0,0,0,23.459,10.988Z",
    transform: "translate(23.616 8.009)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91209",
    "data-name": "Path 91209",
    d: "M7.158,17.827A5.938,5.938,0,1,1,13.1,11.888,5.945,5.945,0,0,1,7.158,17.827Zm0-9.838a3.9,3.9,0,1,0,3.9,3.9A3.9,3.9,0,0,0,7.158,7.988Z",
    transform: "translate(-1.97 3.63)",
    fill: "#09143a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPet);
export default __webpack_public_path__ + "static/media/pet.de46011c1d539f5fbd6789b84ed73ff0.svg";
export { ForwardRef as ReactComponent };